module.exports = __webpack_public_path__ + "static/media/Logo.af0e418b.svg";